import React from 'react'

import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { SectionPanel } from 'routes/Menu/components/Detail/SectionPanel'

import { IngredientsList } from '../IngredientsList/IngredientsList'
import { Allergens } from './Allergens'

type RecipeAllergensProps = {
  allergens?: MenuRecipe['allergens']
  ingredients?: MenuRecipe['ingredients']
  isHeatOnly?: boolean
  loading: boolean
}

export const RecipeAllergens = ({
  allergens,
  ingredients,
  isHeatOnly = false,
  loading,
}: RecipeAllergensProps) => {
  if (loading || ingredients?.length === 0) {
    return null
  }

  const allergenNames = allergens?.map((allergen) => allergen.name) ?? []

  return (
    <SectionPanel data-testing="recipeDetailsAllergenList">
      <IngredientsList ingredients={ingredients} allergens={allergenNames} />
      <Allergens allergens={allergenNames} isHeatOnly={isHeatOnly} />
    </SectionPanel>
  )
}
